import React from 'react';

import { Outlet } from 'react-router-dom';

import { TopSideFooter } from '@zurich-base-ui/layout.top-side-footer';

import { BetaButton, BetaWelcome, TopNav } from 'app/components';

const Portal: React.FC = () => {
  return (
    <TopSideFooter>
      <TopSideFooter.TopBar>
        <TopNav />
      </TopSideFooter.TopBar>
      <TopSideFooter.Main>
        <Outlet />
        <BetaWelcome />
        <BetaButton />
      </TopSideFooter.Main>
    </TopSideFooter>
  );
};

export default Portal;
